<template>
  <v-row justify="center">
    <v-dialog v-model="open" persistent scrollable max-width="800px">
      <v-card class="pa-3">
        <v-card-title class="pa-3">Cadastro de Cliente</v-card-title>
        <v-divider class="mx-3"></v-divider>
        <v-card-text class="pa-0" id="scrollContent">
          <v-container>
            <form autocomplete="off">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    autocomplete="none"
                    label="CPF / CNPJ"
                    v-model="fCpfCnpj"
                    :autofocus="true"
                    maxlength="18"
                    class="py-0"
                    :error="!!errors.cpfCnpj"
                    :error-messages="errors.cpfCnpj"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    autocomplete="none"
                    label="RG / IE"
                    maxlength="20"
                    v-model="fRgIe"
                    class="py-0"
                    :error="!!errors.rgIe"
                    :error-messages="errors.rgIe"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    autocomplete="none"
                    label="Nome / Razão Social"
                    maxlength="80"
                    v-model="cliente.nomeRazaoSocial"
                    class="py-0"
                    :error="!!errors.nomeRazaoSocial"
                    :error-messages="errors.nomeRazaoSocial"
                    v-on:input="() => onInput('nomeRazaoSocial')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    autocomplete="none"
                    maxlength="80"
                    label="Apelido / Nome Fantasia"
                    v-model="cliente.apelidoNomeFantasia"
                    persistent-hint
                    class="py-0"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="9" md="9">
                  <v-text-field
                    autocomplete="none"
                    label="Logradouro"
                    maxlength="50"
                    v-model="cliente.endereco.logradouro"
                    class="py-0"
                    :error="!!errors.endereco.logradouro"
                    :error-messages="errors.endereco.logradouro"
                    v-on:input="() => onInput('endereco.logradouro')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-text-field
                    autocomplete="none"
                    label="Numero"
                    maxlength="10"
                    v-model="cliente.endereco.numero"
                    class="py-0"
                    :error="!!errors.endereco.numero"
                    :error-messages="errors.endereco.numero"
                    v-on:input="() => onInput('endereco.numero')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    autocomplete="none"
                    maxlength="40"
                    label="Complemento"
                    v-model="cliente.endereco.complemento"
                    class="py-0"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    autocomplete="none"
                    label="Bairro"
                    maxlength="40"
                    v-model="cliente.endereco.bairro"
                    class="py-0"
                    :error="!!errors.endereco.bairro"
                    :error-messages="errors.endereco.bairro"
                    v-on:input="() => onInput('endereco.bairro')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="2">
                  <v-text-field
                    autocomplete="none"
                    label="CEP"
                    v-model="fCep"
                    maxlength="9"
                    class="py-0"
                    :error="!!errors.endereco.cep"
                    :error-messages="errors.endereco.cep"
                    v-on:input="() => onInput('endereco.cep')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="8" md="4">
                  <v-select
                    v-if="$vuetify.breakpoint.xs"
                    @change="setEstado"
                    v-model="estado"
                    :items="estadosNomes"
                    label="Estado"
                    :error="!!errors.endereco.estado"
                    :error-messages="errors.endereco.estado"
                    v-on:input="() => onInput('endereco.estado')"
                  ></v-select>
                  <v-autocomplete
                    v-else
                    v-model="estado"
                    @change="setEstado"
                    :items="estadosNomes"
                    label="Estado"
                    autocomplete="none"
                    class="py-0"
                    :error="!!errors.endereco.estado"
                    :error-messages="errors.endereco.estado"
                    v-on:input="() => onInput('endereco.estado')"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-select
                    :disabled="estado === ''"
                    v-if="$vuetify.breakpoint.xs"
                    @change="setCidade"
                    :items="cidadesNomes"
                    v-model="cidade"
                    label="Cidade"
                    :error="!!errors.endereco.cidade"
                    :error-messages="errors.endereco.cidade"
                    v-on:input="() => onInput('endereco.cidade')"
                  ></v-select>
                  <v-autocomplete
                    v-else
                    :disabled="estado === ''"
                    @change="setCidade"
                    :items="cidadesNomes"
                    v-model="cidade"
                    label="Cidade"
                    autocomplete="none"
                    class="py-0"
                    :error="!!errors.endereco.cidade"
                    :error-messages="errors.endereco.cidade"
                    v-on:input="() => onInput('endereco.cidade')"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    autocomplete="none"
                    label="Telefone"
                    v-model="fTelefone"
                    maxlength="15"
                    class="py-0"
                    :error="!!errors.telefone"
                    :error-messages="errors.telefone"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="8" md="8">
                  <v-text-field
                    autocomplete="none"
                    label="Email"
                    maxlength="50"
                    v-model="cliente.email"
                    class="py-0"
                    v-on:input="() => onInput('email')"
                    :error="!!errors.email"
                    :error-messages="errors.email"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-textarea
                    auto-grow
                    v-model="cliente.observacoes"
                    maxlength="512"
                    autocomplete="none"
                    label="Observações"
                    rows="2"
                    row-height="10"
                  ></v-textarea>
                </v-col>
              </v-row>
            </form>
          </v-container>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions class="px-3 pb-2 pt-5">
          <v-row dense>
            <v-col cols="12" sm="6" class="pa-0">
              <label class="error--text pr-3">{{ errorMessage }}</label>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex pa-0" style="justify-content: flex-end;">
              <v-btn class="px-4 mr-2" color="secondary" depressed @click="close">Cancelar</v-btn>
              <v-btn class="px-4" color="primary" depressed @click="save">Salvar</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import api from "../../api/index.js";
import BrV from "br-validations";
import mask from "br-masks";

export default {
  props: ["open", "dadosCliente", "onClose", "onSave"],
  data() {
    return {
      blankErrors: {
        cpfCnpj: null,
        rgIe: null,
        nomeRazaoSocial: null,
        endereco: {
          logradouro: null,
          numero: null,
          bairro: null,
          cep: null,
          estado: null,
          cidade: null
        },
        telefone: null
      },
      novoCliente: {
        cpfCnpj: "",
        rgIe: "",
        nomeRazaoSocial: "",
        apelidoNomeFantasia: "",
        endereco: {
          logradouro: "",
          complemento: "",
          numero: "",
          bairro: "",
          cep: "",
          cidade: 0
        },
        telefone: "",
        email: "",
        observacoes: ""
      },
      errors: null,
      errorMessage: "",
      cliente: null,
      estado: "",
      cidade: "",
      estados: [],
      estadosNomes: [],
      cidades: [],
      cidadesNomes: []
    };
  },
  created: function() {
    this.cliente = { ...this.novoCliente };
    this.errors = { ...this.blankErrors };
    this.estados = api.getEstados();
    this.estadosNomes = this.estados.map(estado => estado.nome);
  },
  watch: {
    dadosCliente: function(newValue, oldValue) {
      if (newValue === null) {
        this.cliente = { ...this.novoCliente };
        this.estado = "";
        this.cidade = "";
        this.cidades = [];
        this.cidadesNomes = [];
      } else {
        const cidadeId = newValue.endereco.cidade;
        this.cliente = { ...newValue };
        const temp = this.estados.find(
          estado =>
            String(estado.id) ===
            String(newValue.endereco.cidade).substring(0, 2)
        );
        this.estado = temp.nome;
        const estadoQuery = this.estados.find(
          estado => estado.nome === this.estado
        );
        this.getCidades(estadoQuery.id);
        this.cliente.endereco.cidade = cidadeId;
        this.cidade = newValue.endereco.cidadeNome;
        delete this.cliente.endereco.cidadeNome;
      }
    }
  },
  computed: {
    fCpfCnpj: {
      get: function() {
        return this.cliente.cpfCnpj;
      },
      set: function(newValue) {
        const temp = newValue.replace(/\D+/g, "");
        if (temp.length <= 11) {
          this.cliente.cpfCnpj = mask.cpf(temp);
        } else {
          this.cliente.cpfCnpj = mask.cnpj(temp);
        }
        this.onInput("cpfCnpj");
      }
    },
    fRgIe: {
      get: function() {
        return this.cliente.rgIe;
      },
      set: function(newValue) {
        if (
          !["isento", "isenta"].includes(newValue.trim().toLowerCase()) &&
          this.cliente.cpfCnpj.replace(/\D+/g, "").length > 11
        ) {
          const temp = newValue.replace(/\D+/g, "");
          if (this.estado && BrV.cnpj.validate(this.cliente.cpfCnpj)) {
            const uf = this.estados.find(estado => estado.nome === this.estado)
              .sigla;
            this.cliente.rgIe = mask.ie(temp, uf).toUpperCase();
            this.onInput("rgIe");
          } else {
            this.cliente.rgIe = temp.trim().toUpperCase();
            this.errors.rgIe = null;
          }
        } else {
          this.cliente.rgIe = newValue.trim().toUpperCase();
        }
      }
    },
    fCep: {
      get: function() {
        return this.cliente.endereco.cep;
      },
      set: function(newValue) {
        this.cliente.endereco.cep = mask.cep(newValue.replace(/\D+/g, ""));
        this.onInput("endereco.cep");
      }
    },
    fTelefone: {
      get: function() {
        return this.cliente.telefone;
      },
      set: function(newValue) {
        this.cliente.telefone = mask.phone(newValue.replace(/\D+/g, "")).trim();
        this.onInput("telefone");
      }
    }
  },
  methods: {
    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    onInput(property) {
      switch (property) {
        case "cpfCnpj": {
          const temp = this.cliente.cpfCnpj.replace(/\D+/g, "");
          if (temp.length <= 11) {
            this.errors.cpfCnpj = BrV.cpf.validate(temp)
              ? null
              : "CPF inválido";
          } else {
            this.errors.cpfCnpj = BrV.cnpj.validate(temp)
              ? null
              : "CNPJ inválido";
          }
          break;
        }

        case "rgIe": {
          const estado = this.estados.find(
            estado => estado.nome === this.estado
          );
          if (estado) {
            if (
              !["isento", "isenta"].includes(this.cliente.rgIe.toLowerCase()) &&
              this.cliente.cpfCnpj.replace(/\D+/g, "").length > 11
            ) {
              this.errors.rgIe = BrV.ie(estado.sigla).validate(
                this.cliente.rgIe
              )
                ? null
                : "IE inválida";
            } else {
              this.errors.rgIe = null;
            }
          } else {
            this.errors.rgIe = null;
          }
          break;
        }

        case "nomeRazaoSocial":
          this.errors.nomeRazaoSocial =
            this.cliente.nomeRazaoSocial.length >= 3
              ? null
              : "Nome / Razão Social inválido";
          break;

        case "endereco.logradouro":
          this.errors.endereco.logradouro =
            this.cliente.endereco.logradouro.length >= 3
              ? null
              : "Logradouro inválido";
          break;

        case "endereco.numero":
          this.errors.endereco.numero =
            this.cliente.endereco.numero.length >= 1 ? null : "Numero inválido";
          break;

        case "endereco.bairro":
          this.errors.endereco.bairro =
            this.cliente.endereco.bairro.length >= 3 ? null : "Bairro inválido";
          break;

        case "endereco.cep":
          this.errors.endereco.cep =
            this.cliente.endereco.cep.length >= 9 ? null : "CEP inválido";
          break;

        case "endereco.estado":
          this.errors.endereco.estado = this.estado ? null : "Estado inválido";
          break;

        case "endereco.cidade":
          this.errors.endereco.cidade = this.cidade ? null : "Cidade inválida";
          break;

        case "telefone":
          this.errors.telefone =
            this.cliente.telefone.length >= 14 ||
            this.cliente.telefone.length === 0
              ? null
              : "Telefone inválido";
          break;

        case "email":
          this.errors.email =
            this.validateEmail(this.cliente.email) || !this.cliente.email
              ? null
              : "Email inválido";
          break;

        default:
          break;
      }
      this.errorMessage = "";

      Object.keys(this.errors).find(key => {
        if (this.errors[key] !== null && typeof this.errors[key] === "object") {
          if (
            Object.keys(this.errors[key]).find(key2 => {
              if (this.errors[key][key2]) {
                this.errorMessage = this.errors[key][key2];
                return true;
              }
            })
          ) {
            return true;
          }
        } else {
          if (this.errors[key]) {
            this.errorMessage = this.errors[key];
            return true;
          }
        }
      });
    },
    setEstado(estadoNome) {
      const estadoQuery = this.estados.find(
        estado => estado.nome === estadoNome
      );
      this.getCidades(estadoQuery.id);
      this.cidade = "";
      this.cliente.endereco.cidade = 0;
    },
    setCidade(cidadeNome) {
      const cidadeQuery = this.cidades.find(
        cidade => cidade.nome === cidadeNome
      );
      this.cliente.endereco.cidade = cidadeQuery.id;
    },
    getCidades(estado) {
      api.getCidades(estado, data => {
        this.cidades = data;
        this.cidadesNomes = data.map(cidade => cidade.nome);
      });
    },
    close() {
      this.goTop();
      this.cliente = { ...this.novoCliente };
      this.errors = { ...this.blankErrors };
      this.onClose();
    },
    save() {
      this.goTop();
      this.onInput("cpfCnpj");
      this.onInput("rgIe");
      this.onInput("nomeRazaoSocial");
      this.onInput("endereco.logradouro");
      this.onInput("endereco.numero");
      this.onInput("endereco.bairro");
      this.onInput("endereco.cep");
      this.onInput("endereco.estado");
      this.onInput("endereco.cidade");
      this.onInput("telefone");
      this.onInput("email");

      if (this.cliente._id) {
        // Editar cliente
        api.patchCliente(this.cliente, data => {
          this.onSave(data);
          this.close();
        });
      } else {
        // Novo cliente
        api.postCliente(this.cliente, data => {
          this.onSave(data, "novoCliente");
          this.close();
        });
      }
    },
    goTop() {
      document.getElementById("scrollContent").scrollTop = 0;
    }
  }
};
</script>
